import * as tree from './tree';
import * as format from './format';
import * as date from './date';
import * as capabilites from './capabilites';
import { getProperty as dotProp } from 'dot-prop';


export default {
	tree,
	format,
	date,
	dotProp,
	capabilites
};
